import { ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

declare module '@mui/material/Radio' {
  // tslint:disable-next-line:interface-name
  interface RadioPropsSizeOverrides {
    large: true;
  }
}

export const MuiRadio: ThemeOptions['components']['MuiRadio'] = {
  defaultProps: { disableRipple: true },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      color: theme.palette.divider,
      padding: theme.spacing(0.5),
      margin: theme.spacing(0.5),
      marginTop: 0,
      ...((ownerState.size === 'large' || ownerState.size === 'small') && {
        marginBottom: theme.spacing(0.25)
      }),
      '& .MuiSvgIcon-root': {
        // specific override for radio button size as requested from design
        fontSize: '18px',
        ...(ownerState.size === 'small' && {
          fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall
        }),
        ...(ownerState.size === 'large' && {
          fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyLarge
        })
      },
      '&.Mui-disabled&:not(.Mui-checked)': {
        color: theme.palette.divider,
        '& .MuiSvgIcon-root[data-testid="RadioButtonCheckedIcon"]': {
          color: theme.palette.action.disabled,
          transform: 'scale(1.6)'
        }
      },
      '&.Mui-checked': {
        color: theme.palette.primary.main,
        '& .MuiSvgIcon-root[data-testid="RadioButtonCheckedIcon"]': {
          transform: 'scale(1.3)'
        },
        '&.Mui-disabled': {
          color: theme.palette.divider,
          '& .MuiSvgIcon-root[data-testid="RadioButtonCheckedIcon"]': {
            color: theme.palette.text.secondary,
            transform: 'scale(1.3)'
          }
        }
      },
      '&.Mui-focusVisible, &:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: '-2px'
      },
      '&.Mui-hover, &:hover': {
        backgroundColor: theme.palette.action.hover
      }
    })
  }
};
